import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import LazyLoad from 'react-lazy-load';
import img from '../../assets/images/lablec_hatter.jpg';
import services from '../../services/services';
import { AppContext } from '../../context/appContext';

const BottomHero = props => {
  const [data, setData] = useState(null);
  const [settings] = useContext(AppContext);

  const getFooterData = async () => {
    const response = await services.getFooterData();

    if (response.data.status === 'OK') {
      const { footerText, imageUrl } = response.data.data;
      const defaultImage = settings?.footerBackgroundImage
        ? `/upload/${settings.footerBackgroundImage}`
        : img;

      setData({
        footerText:
          footerText ||
          `<h1 style="color: white;">KÖSZÖNJÜK, <br />
          HOGY A VÁSÁRLÁSOD IS <br />
          #ÉRINTÉSMENTES!</h1>`,
        imageUrl: imageUrl || defaultImage
      });
    }
  };

  useEffect(() => {
    getFooterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const generateHtml = () => ({ __html: data.footerText });
  return (
    <LazyLoad debounce={false} offsetVertical={750}>
      <Root imageUrl={data?.imageUrl}>
        <Text dangerouslySetInnerHTML={data?.footerText && generateHtml()} />
      </Root>
    </LazyLoad>
  );
};

export default BottomHero;

const Root = styled.div`
  height: auto;
  min-height: 500px;
  background: ${props => `url(${props.imageUrl})`};
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;

  & h1 {
    font-size: 3.2em;
  }

  & h2 {
    font-size: 2.4em;
  }

  & h3 {
    font-size: 2.08em;
  }

  & h4 {
    font-size: 1.6em;
  }

  & h5 {
    font-size: 1.28em;
  }

  & h6 {
    font-size: 1.12em;
  }

  @media (max-width: 600px) {
    & h1 {
      font-size: 2em;
    }

    & h2 {
      font-size: 1.5em;
    }

    & h3 {
      font-size: 1.3em;
    }

    & h4 {
      font-size: 1em;
    }

    & h5 {
      font-size: 0.8em;
    }

    & h6 {
      font-size: 0.7em;
    }
  }
`;

const Text = styled.div`
  width: 100%;
  & > * {
    margin-left: 10%;
    margin-right: 10%;
    width: 80%;
    min-height: 14px;
  }
`;
